<template lang="pug">
f7-page#curriculum-detail
  navbar(title="カリキュラム" back)

  background
    .curriculum-detail
      curriculum-query(:curriculumId="curriculumId")
        template(slot="loaded" slot-scope="{ curriculum }")
          curriculum-top-view(
            v-if="curriculum"
            class="curriculum-top-view"
            :curriculum="curriculum"
            @click="playbackVideo")

          .step-box(v-for="(step, index) in curriculum.steps")
            curriculum-step-view(
              :key="step.id"
              :step="step"
              :number="index + 1"
              class="curriculum-step-view"
              @click="playbackVideo")
</template>

<style lang="scss" scoped>
.curriculum-detail {
  padding: 32px 8px;

  .curriculum-top-view {
    padding: 0 16px;
  }

  .step-box {
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    margin-top: 24px;

    .curriculum-step-view {
      padding: 0 16px;
      margin-top: 24px;
    }
  }
}
</style>

<script>
import PageTitle from '@/components/mixins/PageTitle'
import VideoPlayable from '@/components/mixins/VideoPlayable'
import CurriculumQuery from '@/components/queries/CurriculumQuery'
import CurriculumTopView from '@/components/organisms/CurriculumTopView'
import CurriculumStepView from '@/components/organisms/CurriculumStepView'

export default {
  mixins: [PageTitle, VideoPlayable],
  title: 'カリキュラム',
  components: {
    CurriculumQuery,
    CurriculumTopView,
    CurriculumStepView,
  },
  data() {
    return {
      curriculumId: null,
    }
  },
  created() {
    this.curriculumId = this.$f7route.params.curriculumId
  },
}
</script>
